/*! Copyright (c) Safe As Milk. All rights reserved. */
import { debounce } from "utils";

class BlogMasonry extends HTMLElement {
    #boundLayout;
    #resizeObserver;
    connectedCallback() {
        this.#boundLayout = debounce(this.layout.bind(this), 100);
        this.layout();
        this.querySelectorAll("img").forEach((img => {
            if (img.complete) return;
            img.addEventListener("load", this.#boundLayout, { once: true });
        }));
        this.#resizeObserver = new ResizeObserver(this.#boundLayout);
        this.#resizeObserver.observe(this);
    }
    disconnectedCallback() {
        if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = null;
        }
    }
    layout() {
        const items = Array.from(this.children);
        if (!items.length) return;
        const columnCount = parseInt(getComputedStyle(this).getPropertyValue("--masonry-columns"), 10) || 1;
        if (columnCount <= 1) {
            this.style.height = "";
            items.forEach((item => {
                item.style.position = "";
                item.style.left = "";
                item.style.top = "";
                item.style.width = "";
            }));
            return;
        }
        const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
        const containerWidth = this.offsetWidth;
        const columnWidth = (containerWidth - gap * (columnCount - 1)) / columnCount;
        const columnHeights = new Array(columnCount).fill(0);
        items.forEach((item => {
            let shortest = 0;
            for (let i = 1; i < columnCount; i++) {
                if (columnHeights[i] < columnHeights[shortest]) shortest = i;
            }
            item.style.position = "absolute";
            item.style.width = `${columnWidth}px`;
            item.style.left = `${shortest * (columnWidth + gap)}px`;
            item.style.top = `${columnHeights[shortest]}px`;
            columnHeights[shortest] += item.offsetHeight;
        }));
        this.style.height = `${Math.max(...columnHeights)}px`;
    }
}

customElements.define("blog-masonry", BlogMasonry);

export default BlogMasonry;
